import React from 'react';
import { PropTypes } from 'prop-types';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? '#246EFF' : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';

    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19.6923" cy="20" r="19.6923" fill={fill} />
            <path d="M23.6361 13.5935V11.3077" stroke={stroke} strokeLinecap="square" />
            <path d="M16.3636 13.5935V11.3077" stroke={stroke} strokeLinecap="square" />
            <path d="M12 16.6411H28" stroke={stroke} />
            <rect x="12" y="13.5935" width="16" height="13.7143" stroke={stroke} strokeLinecap="square" />
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';

    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6363 3.59345V1.30774" stroke={stroke} strokeLinecap="square" />
            <path d="M5.36364 3.59345V1.30774" stroke={stroke} strokeLinecap="square" />
            <path d="M1 6.64108H17" stroke={stroke} />
            <rect x="1" y="3.59351" width="16" height="13.7143" stroke={stroke} strokeLinecap="square" />
        </svg>
    );
};

const MenuEvents = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuEvents.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuEvents;
